import { Dropdown } from 'components/filters/Dropdown';
import { FormInput_text } from 'components/form/formInput/FormInput_text';
import { deepCloneArray, isArray, isArrayNotEmpty } from 'functions';
import { useCustomSelector } from 'hooks';
import React, { useEffect, useState } from 'react';
import ic_remove_row from "assets/images/ic_remove_row.svg";
import { Button } from 'components/buttons/Button';
import { Toaster } from 'components/notification/Toaster';

export default function ProductInfo({
    setupInfo, list, setList, initList
}) {
    const { licenseProducts } = useCustomSelector("recursiveBillingSetup");

    return (
        <>
            {/* Common Info */}
            <div className={"product-info__common-info d-flex flex-wrap"}>
                {/* Charge Method */}
                <FormInput_text
                    className={"common-info__charge-method"}
                    inputLabel={"Charge Method"}
                    inputValue={setupInfo?.ChargeMethod}

                    isInputOptional isMarginBtmOptional isInputDisabled
                />

                {/* Subscription Method */}
                <FormInput_text
                    className={"common-info__subscription-method"}
                    inputLabel={"Subscription Method"}
                    inputValue={setupInfo?.SubscriptionMethod}

                    isInputOptional isMarginBtmOptional isInputDisabled
                />

                {/* Bill Frequency */}
                 <FormInput_text
                    className={"common-info__bill-frequency"}
                    inputLabel={"Bill Frequency"}
                    inputValue={setupInfo?.BillFrequence}

                    isInputOptional isMarginBtmOptional isInputDisabled
                />

                {/* Quantity */}
                <FormInput_text
                    className={"common-info__qty"}
                    inputLabel={"Quantity"}
                    inputValue={setupInfo?.Quantity}

                    isInputOptional isMarginBtmOptional isInputDisabled
                />

                {/* Unit Discount Amount */}
                <FormInput_text
                    className={"common-info__unit-discount-amount"}
                    inputLabel={"Unit Discount Amount (RM)"}
                    inputValue={setupInfo?.UnitDiscountAmount}

                    isInputOptional isMarginBtmOptional isInputDisabled
                />
            </div>

            {/* Product List */}
            <div className={"product-info__product-list"}>
                {/* Existing Setup */}
                {isArrayNotEmpty(initList) && initList.map(((obj, idx) => {
                    return (
                        <div key={idx} className={"d-flex align-items-center"}>
                            {/* Product Code */}
                            <FormInput_text
                                className={"product-list__product-code"}
                                inputLabel={"Product Code"}
                                inputValue={obj?.ProductCode}

                                isInputOptional isMarginBtmOptional isInputDisabled
                            />

                            {/* Product Name */}
                            <FormInput_text
                                className={"product-list__product-name"}
                                inputLabel={"Product Name"}
                                inputValue={obj?.ProductName}

                                isInputOptional isMarginBtmOptional isInputDisabled
                            />

                            {/* Unit Price */}
                            <FormInput_text
                                className={"product-list__unit-price"}
                                inputLabel={"Unit Price (RM)"}
                                inputValue={obj?.UnitPrice}

                                isInputOptional isMarginBtmOptional isInputDisabled
                            />
                        </div>
                    )
                }))}

                {/* Editable */}
                {isArrayNotEmpty(list) && list.map((obj, idx) => {

                    return (
                        <div key={idx} className={"d-flex align-items-center"}>
                            {/* Product Code */}
                            {obj?.ProductCode? (
                                <FormInput_text
                                    className={"product-list__product-code"}
                                    inputLabel={"Product Code"}
                                    inputValue={obj?.ProductCode}

                                    isInputOptional isMarginBtmOptional isInputDisabled
                                />
                            ):(
                                <Dropdown
                                    className={"product-list__product-code"}
                                    label={"Product Code"}

                                    options={isArrayNotEmpty(licenseProducts)? licenseProducts.map((obj) => {
                                        return {
                                            label: obj?.ProductCode,
                                            value: obj?.ProductCode
                                        }
                                    })
                                    :[]}
                                    valueFromParent={obj?.ProductCode}
                                    onChange={(value, label, index) => {
                                        // Store data
                                        let newList = deepCloneArray(list);
                                        newList.pop();
                                        newList.push({
                                            ProductCode: value,
                                            ProductName: licenseProducts[index]?.ProductName,
                                            UnitPrice: licenseProducts[index]?.UnitPrice,
                                        })
                                        setList(newList);
                                    }}

                                    isSearchable
                                    isDisabled={list.length - 1 > idx}
                                />
                            )}

                            {/* Product Name */}
                            <FormInput_text
                                className={"product-list__product-name"}
                                inputLabel={"Product Name"}
                                inputValue={obj?.ProductName}

                                isInputOptional isMarginBtmOptional isInputDisabled
                            />

                            {/* Unit Price */}
                            <FormInput_text
                                className={"product-list__unit-price"}
                                inputLabel={"Unit Price (RM)"}
                                inputValue={obj?.UnitPrice}

                                isInputOptional isMarginBtmOptional isInputDisabled
                            />

                            {/* Remove Icon */}
                            <img
                                className={"product-list__remove-icon"}
                                src={ic_remove_row}
                                onClick={() => {
                                    let newList = deepCloneArray(list);
                                    newList.splice(idx, 1);
                                    setList(newList);
                                }}
                            />
                        </div>
                    )
                })}

                {/* Actions */}
                <div className={"product-list__actions"}>
                    {/* Add Product */}
                    <Button
                        className={"actions__add-product"}
                        handleOnClick={() => {
                            let newList = deepCloneArray(list);
                            newList.push({});
                            setList(newList);
                        }}
                    >
                        Add Product
                    </Button>

                    {/* Add All Products */}
                    <Button
                        className={"actions__add-all-products"}
                        handleOnClick={() => {
                            if (isArrayNotEmpty(licenseProducts)) {
                                let newList = licenseProducts.map((obj) => {
                                    return {
                                        ProductCode: obj?.ProductCode,
                                        ProductName: obj?.ProductName,
                                        UnitPrice: obj?.UnitPrice
                                    }
                                });
                                setList(newList);
                            }
                            else {
                                Toaster({
                                    type: "info",
                                    msg: "No license product found"
                                })
                            }
                        }}
                    >
                        Add All Products
                    </Button>
                </div>
            </div>
        </>
    );
}